InfoBox.prototype.getCloseBoxImg_ = function () {
    return '<div class="A-mapInfoBox__close"><svg class="A-mapInfoBox__icon ni-icon"><use xlink:href="/src/icons/nova-icons-basic.svg?{{buildVersion}}#close"></use></svg></div>';
};
